import React from 'react';
import {View} from 'react-native';
import {colorPalette} from '../../../theme';
import styles from './BaseField.style';

export default function BaseField(props) {
  const {
    containerStyle,
    children,
    footerChildren,
    isError,
    isFocus,
    inputAreaStyle,
    isSuccess,
  } = props;

  return (
    <View style={[styles.container, containerStyle]}>
      <View
        style={[
          styles.textInputArea,
          {
            borderColor: isSuccess
              ? colorPalette.successDarker
              : isError
              ? colorPalette.errorMain
              : isFocus
              ? colorPalette.purple500
              : colorPalette.grey3,
            borderWidth: isSuccess ? 2 : isError ? 2 : isFocus ? 2 : 1,
          },
          !isError &&
            !isFocus && {
              padding: 1,
            },
          inputAreaStyle,
        ]}>
        {children}
      </View>
      {footerChildren}
    </View>
  );
}
